import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "../lib/api";

// Paso 1 del alta automática: el panel lee TODA la carpeta de Drive y devuelve un resumen (sin contraseñas).
export function useDiscoverProject() {
  return useMutation({
    mutationFn: async ({ name, driveFolder, requestId }) => {
      const { data } = await apiClient.post("/projects/discover", { name, drive_folder: driveFolder, request_id: requestId });
      return data;
    },
  });
}

// Paso 2: con el OK del usuario se crea el proyecto, se conectan los servidores y se prueban.
export function useCommitDiscovery() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ sessionId, name, description, systemPrompt, requestId, excludeKeys }) => {
      const { data } = await apiClient.post("/projects/discover/commit", {
        session_id: sessionId,
        name,
        description,
        system_prompt: systemPrompt,
        request_id: requestId,
        exclude_keys: excludeKeys || [],
      });
      return data;
    },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ["projects"] }),
  });
}

// «Releer carpeta» de un proyecto ya creado: compara Drive con lo conectado (nuevos, cambios, ya no aparecen).
export function useRediscoverProject(projectId) {
  return useMutation({
    mutationFn: async ({ requestId }) => {
      const { data } = await apiClient.post(`/projects/${projectId}/rediscover`, { request_id: requestId });
      return data;
    },
  });
}

export function useCommitRediscover(projectId) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ sessionId, selectedKeys, requestId }) => {
      const { data } = await apiClient.post(`/projects/${projectId}/rediscover/commit`, {
        session_id: sessionId,
        selected_keys: selectedKeys,
        request_id: requestId,
      });
      return data;
    },
    onSettled: () => queryClient.invalidateQueries({ queryKey: ["servers", projectId] }),
  });
}

// Qué está listo y qué falta de un proyecto. La clave empieza con ["servers", id] para que se refresque sola cuando se
// guarda o cambia un servidor (p. ej. al pegar una credencial con el candado). `poll`: sigue consultando mientras analiza.
export function useReadiness(projectId, { poll = false } = {}) {
  return useQuery({
    queryKey: ["servers", projectId, "readiness"],
    queryFn: async () => (await apiClient.get(`/projects/${projectId}/readiness`)).data,
    enabled: !!projectId,
    refetchInterval: poll ? (query) => (query.state.data?.analyzing ? 3000 : false) : false,
    retry: false,
  });
}
